import { ca } from '../i18n/ca';

/** The values the web app has a Catalan word for, in the order the filter lists them. */
export const KNOWN_REPORT_STATUSES = Object.keys(ca.reportStatus);

/** The panel's own spelling of a match's status, upper-cased the way `PanelMatch.isLive` reads it. */
const key = (status: string) => status.trim().toUpperCase();

/**
 * What a person reads for a match's status as the panel sends it. A value the
 * web app has no word for is never shown alone: `label` is a neutral word and
 * `raw` carries the value for the small print next to it (null when known).
 */
export function reportStatusLabel(status: string): { label: string; raw: string | null } {
  const known = ca.reportStatus[key(status)];
  if (known) return { label: known, raw: null };
  return { label: ca.reportStatusUnknown, raw: status };
}

/** The same as one string, for a place with no room for small print (an option in a list). */
export function reportStatusText(status: string): string {
  const { label, raw } = reportStatusLabel(status);
  return raw === null ? label : `${label} (${raw})`;
}
